/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-inner-declarations */
/* eslint-disable radix */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/extensions */
import { useRouter } from "next/router";
import {
	Axios,
	ScrollToUp,
} from "Helpers/utils";
import { useEffect, useState } from "react";
import { END } from "redux-saga";
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import * as ServerCookies from "cookies";
import Data from "Consts/data";
import dynamic from "next/dynamic";
import { loadProducts } from "@/Store/products_store/lib/actions";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";
import { wrapper } from "@/Store/index";
import { loadCategory } from "@/Store/category_store/lib/actions";
import { loadBrands } from "@/Store/brands_store/lib/actions";
import { loadCategoryDetail } from "@/Store/category_detail_store/lib/actions";

const Layout = dynamic(
	() => import("Containers/layout"),
	{ ssr: false },
);
const Mobile = dynamic(
	() => import("./mobile"),
	{ ssr: false },
);
const Desktop = dynamic(
	() => import("./desktop"),
	{ ssr: false },
);
const Popup = dynamic(
	() => import("Components/pdp-popup"),
	{ ssr: false },
);
const AddToCartPopup = dynamic(
	() => import("Components/add-to-cart-popup"),
	{ ssr: false },
);
const Drawer = dynamic(
	() => import("Components/drawer"),
	{ ssr: false },
);
const Loader = dynamic(
	() => import("@fdn/loader"),
	{ ssr: false },
);
const ModalQuickReview = dynamic(
	() => import("Components/modal-quick-review"),
	{ ssr: false },
);
const ChildDetailQuickReview = dynamic(
	() => import("Containers/child-detail-quick-review"),
	{ ssr: false },
);

const Category = (props) => {

	const data = props;
	const {
		extractCat,
		extractParCat,
		extractSubCat,
		extractBrand,
		bannerImage,
	} = data;
	const router = useRouter();

	const [isLoadingProducts, setIsloadingProducts] = useState(true);
	const [isLoadingQuickReview, setIsloadingQuickReview] = useState(false);
	const [listProducts, setListProducts] = useState(null);
	const [isShowFilter, setShowFilter] = useState(false);
	const [isShowSorter, setShowSorter] = useState(false);
	const [filter, setFilter] = useState({
		category: data.query && data.query.category ? data.query.category.split(",") : [],
		brand: data.query && data.query.brand ? data.query.brand.split(",") : [],
		minPrice: data?.query?.min_price ?? "",
		maxPrice: data?.query?.max_price ?? "",
		onSale: Number(data?.query?.sale) || 0,
	});
	const [sorting, setSorting] = useState();
	const [page, setPage] = useState(data.query.page);
	const [totalPage, setTotalPage] = useState();
	const [total, setTotal] = useState(0);
	const [productQuickReview, setProductQuickReview] = useState([]);
	const [isModalQuickReview, setModalQuickReview] = useState(false);
	const [addToCartLoading, setAddToCartLoading] = useState(false);
	const [addToCartPopupShow, setAddToCartPopupShow] = useState({
		show: false,
		addedProduct: {},
		productId: 0,
	});
	const [popupShow, setPopupShow] = useState({
		show: false,
		message: "",
		color: "#323942",
		redirect: false,
		closable: false,
	});

	// global slug
	const categorySlug = data?.query?.categoryslug && Array.isArray(data.query.categoryslug)
		? data.query.categoryslug[data.query.categoryslug.length - 1]
		: data.query.categoryslug;
	const slug = categorySlug ?? "";

	// global query
	const query = data.query && data.query.query ? data.query.query : "";

	// global filter category
	const category = filter && filter.category && filter.category.length > 0
		? filter.category.map((item) => item.entity_id
			|| item.id
			|| extractCat[item]?.toString()
			|| extractSubCat[item]?.toString()
			|| extractParCat[item])?.toString()
		: "";

	// global filter brands
	const brands = filter && filter.brand ? filter.brand.map((brand) => (brand.id || brand)) : "";

	// global filter on sale
	const onSale = filter?.onSale ? "1" : "";

	const HandleFilter = (type, val, input) => {

		const temp = !input
			? Array.isArray(val) ? val : [...filter[type], val]
			: val;

		setPage(1);
		setFilter({
			...filter,
			[type]: temp,
		});

	};

	const HandleFilterRemove = (type, val) => {

		if (type === "price") {

			setFilter({
				...filter,
				minPrice: "",
				maxPrice: "",
			});

		} else {

			setFilter({
				...filter,
				[type]: type === "onSale" ? val : filter && filter[type].filter((i) => (
					i !== val && i !== val?.id && i !== val?.slug
				)),
			});

		}

	};

	const HandleFilterSave = async () => {

		try {

			setIsloadingProducts(true);
			const parentCategory = slug;

			const listData = await fetch(`/api/fds-product?page=${page || "1"}&limit=${data.isMobile ? "10" : "12"}&parent_category=${parentCategory}&category=${category}&sort=${sorting || ""}&brand=${brands}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${onSale}&query=${encodeURIComponent(query) || ""}&placement=${query?.length > 0 ? 3 : 2}`, { headers: { ...Env.HEADERS, key: process.env.NEXT_PUBLIC_KEY_API_CLIENT } });
			const res = await listData.json();

			if (res && res.data) {

				setPage(parseInt(res && res.pagination && res.pagination.page));
				setTotalPage(parseInt(res && res.pagination && res.pagination.total_page));
				setTotal(parseInt(res && res.pagination && res.pagination.total));
				setIsloadingProducts(false);
				if (listProducts !== undefined) {

					if (!data.query.categoryslug) {

						router.push(
							`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/search?page=${page || "1"}&sort=${sorting || ""}&category=${filter && filter.category && filter.category.map((item) => item.category_slug || item.slug || item).toString()}&brand=${filter && filter.brand && filter.brand.length > 0 ? filter.brand.map((item) => extractBrand[item]) : ""}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${filter?.onSale ? 1 : 0}&query=${encodeURIComponent(query || "")}`,
							undefined,
							{ shallow: true },
						);

					} else {

						router.push(
							`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/category/${data && data.query && data.query.categoryslug && data.query.categoryslug.toString().replace(/[,]/g, "/")}?page=${page || "1"}&sort=${sorting || ""}&category=${filter && filter.category && filter.category.map((item) => item.category_slug || item.slug || item).toString()}&brand=${brands}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${filter?.onSale ? 1 : 0}&query=${encodeURIComponent(query || "")}`,
							undefined,
							{ shallow: true },
						);

					}

				}

				setListProducts(res.data);

			} else {

				setIsloadingProducts(false);
				setListProducts(null);

			}

		} catch (err) {

			setPopupShow({
				show: true,
				message: "Something went wrong. Please try again later.",
				color: "#323942",
			});

		}

	};

	const handleFilterReset = () => {

		setFilter({
			brand: [],
			category: [],
			onSale: "",
			minPrice: "",
			maxPrice: "",
		});

	};

	const HandleLoadMore = async (e) => {

		try {

			ScrollToUp();
			setPage(e);
			setIsloadingProducts(true);

			const parentCategory = slug;

			const listData = await fetch(`/api/fds-product?page=${e}&limit=${data.isMobile ? "10" : "12"}&parent_category=${parentCategory}&category=${category}&sort=${sorting || ""}&brand=${brands}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${onSale}&query=${query || ""}&placement=${query?.length > 0 ? 3 : 2}`, { headers: { ...Env.HEADERS, key: process.env.NEXT_PUBLIC_KEY_API_CLIENT } });
			const res = await listData.json();

			if (res && res.data && res.data) {

				setIsloadingProducts(false);
				if (!data.query.categoryslug) {

					router.push(
						`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/search?page=${e || "1"}&sort=${sorting || ""}&category=${filter && filter.category && filter.category.map((item) => item.category_slug || item.slug || item).toString()}&brand=${filter && filter.brand && filter.brand.length > 0 ? filter.brand.map((item) => extractBrand[item]) : ""}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${filter?.onSale ? 1 : 0}&query=${encodeURIComponent(query || "")}`,
						undefined,
						{ shallow: true },
					);

				} else {

					router.push(
						`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/category/${data && data.query && data.query.categoryslug && data.query.categoryslug.toString().replace(/[,]/g, "/")}?page=${e || "1"}&sort=${sorting || ""}&category=${filter && filter.category && filter.category.map((item) => item.category_slug || item.slug || item).toString()}&brand=${brands}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${filter?.onSale ? 1 : 0}&query=${encodeURIComponent(query || "")}`,
						undefined,
						{ shallow: true },
					);

				}

				setListProducts(res.data);

			}

		} catch (err) {

			setIsloadingProducts(false);
			setPopupShow({
				show: true,
				message: "Something went wrong. Please try again later.",
				color: "#323942",
			});

		}

	};

	const HandleShowFilter = (params) => {

		setShowFilter(params);

	};

	const HandleShowSorter = (params) => {

		setShowSorter(params);

	};

	const HandleSorting = async (params) => {

		try {

			setSorting(params);
			setIsloadingProducts(true);

			const parentCategory = slug;

			const listData = await fetch(`/api/fds-product?page=${page}&limit=${data.isMobile ? "10" : "12"}&parent_category=${parentCategory}&category=${category}&sort=${params}&brand=${brands}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${onSale}&query=${encodeURIComponent(query)}&placement=${query?.length > 0 ? 3 : 2}`, { headers: { ...Env.HEADERS, key: process.env.NEXT_PUBLIC_KEY_API_CLIENT } });
			const res = await listData.json();

			if (res && res.data && res.data) {

				setIsloadingProducts(false);
				if (!data.query.categoryslug) {

					router.push(
						`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/search?page=${page || "1"}&sort=${sorting || ""}&category=${filter && filter.category && filter.category.map((item) => item.category_slug || item.slug || item).toString()}&brand=${filter && filter.brand && filter.brand.length > 0 ? filter.brand.map((item) => extractBrand[item]) : ""}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${filter?.onSale ? 1 : 0}&query=${encodeURIComponent(query || "")}`,
						undefined,
						{ shallow: true },
					);

				} else {

					router.push(
						`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/category/${data && data.query && data.query.categoryslug && data.query.categoryslug.toString().replace(/[,]/g, "/")}?page=${page || "1"}&sort=${params || ""}&category=${filter && filter.category && filter.category.map((item) => item.category_slug || item.slug || item).toString()}&min_price=${filter && filter.minPrice}&max_price=${filter && filter.maxPrice}&sale=${filter?.onSale ? 1 : 0}&brand=${brands}&query=${encodeURIComponent(query || "")}`,
						undefined,
						{ shallow: true },
					);

					setListProducts(res && res.data && res.data);

				}

			}

		} catch (err) {

			setIsloadingProducts(false);
			setPopupShow({
				show: true,
				message: "Something went wrong. Please try again later.",
				color: "#323942",
			});

		}

	};

	const HandleQuickReview = async (params) => {

		try {

			setModalQuickReview(true);
			setIsloadingQuickReview(true);
			const resProduct = await Axios(`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-product/${params}`);
			if (resProduct
				&& resProduct.data
				&& resProduct.data.meta
				&& resProduct.data.meta.code === 200) {

				setProductQuickReview(resProduct.data.data.product);
				setIsloadingQuickReview(false);

			}

		} catch (err) {

			setPopupShow({
				show: true,
				message: "Something went wrong. Please try again later.",
				color: "#323942",
			});

		}

	};

	useEffect(() => {

		if (data.query && data.query.sort) {

			setSorting(data.query.sort);

		}

		setFilter({
			...filter,
			brand: data.query && data.query.brand ? data.query.brand.split(",") : [],
			category: data.query && data.query.category ? data.query.category.split(",") : [],
		});

	}, [data.query]);

	useEffect(() => {

		setIsloadingProducts(true);

		HandleFilterSave();

		setIsloadingProducts(false);

	}, [
		filter?.category?.length,
		filter?.brand?.length,
		filter?.minPrice, filter?.maxPrice,
		filter?.onSale]);

	const staticMeta = typeof data.query?.categoryslug !== "undefined"
		? data.query?.categoryslug[data.query?.categoryslug?.length - 1].replace(/[-]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
		: data.query?.query?.replace(/[-]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

	/**
	 * curated filter category using slug
	 * - use default filter if category has no child and not virtual product category
	 * - use [] if virtual product category (x-beauty)
	 * - use filtered category (child) if category has child
	 */
	const listCategorySlug = data.query.categoryslug;

	const selectedCategoryDesktop = listCategorySlug
		? data?.storeCategoryDesktop?.filter((item) => item.slug === listCategorySlug?.[0])
		: data?.storeCategoryDesktop;

	const defaultCategoryDesktop = data?.storeCategoryDesktop?.filter((item) => item.slug === "shop-all")[0]?.items;

	const filteredCategoryDesktop = selectedCategoryDesktop && (selectedCategoryDesktop[0]?.is_virtual || selectedCategoryDesktop[0]?.slug.includes("x-beauty"))
		? selectedCategoryDesktop[0]?.items
		: defaultCategoryDesktop;

	return (
		<Layout
			home
			title="Femaledaily"
			typeNavbarSecondary="type-1"
			titleNavbar={categorySlug ? categorySlug
				.replace(/[-]/g, " ")
				.replace(/\b\w/g, (l) => l.toUpperCase()) : data.query.query}
			ismobile={data.isMobile}
			self={data.getStoreSelf}
			categoryDesktop={data && data.storeCategoryDesktop}
			getQuoteIdErrMessage={data.getQuoteIdErrMessage}
			metaTitle={data?.getMeta?.meta_title?.split("|")[0] || `Jual Produk ${staticMeta} Terlengkap dan Berkualitas`}
			metaDescription={data?.getMeta?.meta_description || `Jual Produk ${staticMeta} Berkualitas. Belanja Makeup Online Terpercaya di FD Studio by Female Daily`}
			metaKeywords={data?.getMeta?.meta_keywords || null}
			isAdaptiveLoad
		>
			{data.isMobile
				? (
					<Mobile
						data={data}
						slug={categorySlug ?? data.query.query}
						setShowFilter={(val) => HandleShowFilter(val)}
						setShowSorter={(val) => HandleShowSorter(val)}
						setSorting={(val) => HandleSorting(val)}
						isShowFilter={isShowFilter}
						listProducts={listProducts}
						sorting={sorting}
						page={page}
						total={total}
						totalPage={totalPage}
						isLoadingProducts={isLoadingProducts}
						isShowSorter={isShowSorter}
						handleLoadMore={(val) => HandleLoadMore(val)}
						handleQuickReview={HandleQuickReview}
						filter={filter}
						handleFilter={(type, val, input) => HandleFilter(type, val, input)}
						handleFilterRemove={(type, val) => HandleFilterRemove(type, val)}
						handleFilterSave={HandleFilterSave}
						handleFilterReset={handleFilterReset}
						bannerImage={bannerImage}
						extractBrand={extractBrand}
						listCategory={filteredCategoryDesktop}
						defaultListCategory={defaultCategoryDesktop}
					/>
				)
				: (
					<Desktop
						data={data}
						page={page}
						total={total}
						filter={filter}
						sorting={sorting}
						totalPage={totalPage}
						sortingData={Data.SORT_BY}
						isShowSorter={isShowSorter}
						listProducts={listProducts}
						slug={categorySlug ?? data.query.query}
						isLoadingProducts={isLoadingProducts}
						setShowSorter={(val) => setShowSorter(val)}
						setSorting={(val) => HandleSorting(val)}
						handleLoadMore={(val) => HandleLoadMore(val)}
						handleQuickReview={HandleQuickReview}
						isLoadingQuickReview={isLoadingQuickReview}
						productQuickReview={productQuickReview}
						isModalQuickReview={isModalQuickReview}
						handleFilterReset={() => handleFilterReset()}
						setModalQuickReview={(val) => setModalQuickReview(val)}
						handleFilterRemove={(type, val) => HandleFilterRemove(type, val)}
						handleFilterDesktop={(type, val, input) => HandleFilter(type, val, input)}
						bannerImage={bannerImage}
						extractBrand={extractBrand}
						extractParCat={extractParCat}
						listCategory={filteredCategoryDesktop}
						defaultListCategory={defaultCategoryDesktop}
						popupShow={popupShow}
						setPopupShow={(val) => {

							setPopupShow(val);

						}}
						setAddToCartLoading={(val) => setAddToCartLoading(val)}
						setAddToCartPopupShow={(val) => setAddToCartPopupShow(val)}
					/>
				)}

			<Popup
				closable={false}
				isMobile={data.isMobile}
				color={popupShow?.color}
				show={popupShow?.show}
				onHide={() => setPopupShow(false)}
				text={popupShow?.message}
				withOk={false}
			/>

			<ModalQuickReview
				show={isModalQuickReview}
				onClick={() => setModalQuickReview(false)}
				closable
			>
				<ChildDetailQuickReview
					data={productQuickReview}
					isLoading={isLoadingQuickReview}
					closeModal={() => setModalQuickReview(false)}
					setPopupShow={(e) => setPopupShow(e)}
					setAddToCartLoading={(e) => setAddToCartLoading(e)}
					setAddToCartPopupShow={(e) => setAddToCartPopupShow(e)}
				/>
			</ModalQuickReview>

			<Drawer
				isMobile={false}
				contentBackground="#FFF"
				title="Added to Cart!"
				headerIconSrc="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/fdn-studio-new/static/added-to-cart.png"
				onHide={() => setAddToCartPopupShow((prev) => ({
					show: false,
					addedProduct: prev.addedProduct,
					productId: prev.productId,
				}))}
				type="with-overlay"
				show={addToCartPopupShow?.show}
			>
				<AddToCartPopup
					isMobile={false}
					addedProduct={addToCartPopupShow?.addedProduct}
					productId={addToCartPopupShow?.productId}
				/>
			</Drawer>

			{addToCartLoading && (
				<>
					<div className="fdn-loader">
						<Loader />
					</div>
					<style>
						{`
							.fdn-loader {
								position:absolute;
							}
						`}
					</style>
				</>
			)}

		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({
		store, req, res: resServer, query,
	}) => {

		let userAgent;
		// let cookies;
		let authorization = null;
		let usrname = null;

		const extractCat = {};
		const extractSubCat = {};
		const extractParCat = {};
		const extractBrand = {};

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const Cookie = new ServerCookies(req, resServer);
		/* START CREATE QUOTE ID */
		// const getQuoteIdErrMessage = await HandleCreateQuote({ Cookies: Cookie });
		const getQuoteIdErrMessage = null;
		/* END CREATE QUOTE ID */

		if (req.headers.cookie) {

			authorization = Cookie.get("token");
			usrname = Cookie.get("usrname");

		}

		await store.dispatch(
			loadSelf({
				payload: {
					api_env: process.env.NEXT_PUBLIC_NODE_ENV,
					env: Env.HEADERS,
					usrname,
					Authorization: authorization,
					is_server: true,
				},
			}),
		);

		await store.dispatch(
			loadProducts({
				payload: {
					page: query && query.page || "1",
					limit: "12",
					category: query && query.categoryslug && query.categoryslug.length > 0
						? query && query.category && query.category.split(",") && query.category.split(",").length > 0
							? query.categoryslug[query.categoryslug.length - 1].split().concat(query.category.split(",")).toString()
							: query.categoryslug[query.categoryslug.length - 1]
						: "",
					brand: query && query.brand,
					sort: query && query.sort || "",
					placement: query && query?.query?.length > 0 ? 3 : 2,
					query: query && query.query || "",
				},
			}),
		);

		await store.dispatch(
			loadCategoryDesktop({
				payload: {
				},
			}),
		);

		await store.dispatch(
			loadCategory(),
		);

		await store.dispatch(
			loadCategoryDetail({
				slug: typeof query?.categoryslug !== "undefined"
					? query?.categoryslug[query?.categoryslug?.length - 1]
					: query?.query,
			}),
		);

		await store.dispatch(
			loadBrands({
				payload: {
					limit: "1000",
					sort: "name",
				},
			}),
		);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const getStoreSelf = store.getState().storeSelf && typeof store.getState().storeSelf.data !== "undefined"
			? store.getState().storeSelf
			: null;

		const getStoreCategory = store.getState().storeCategory.data && typeof store.getState().storeCategory.data.data !== "undefined"
			? store.getState().storeCategory.data
			: null;

		const getStoreCategoryDetail = store.getState().storeCategoryDetail.data && typeof store.getState().storeCategoryDetail.data.data !== "undefined"
			? store.getState().storeCategoryDetail.data
			: null;

		const storeCategory = [];

		const getStoreProducts = store.getState().storeProducts.data && typeof store.getState().storeProducts.data.data !== "undefined"
			? store.getState().storeProducts.data
			: null;

		const getStoreCategoryDesktop = store.getState().storeCategoryDesktop.data && typeof store.getState().storeCategoryDesktop.data.data !== "undefined"
			? store.getState().storeCategoryDesktop.data
			: null;

		const getStoreBrands = store.getState().storeBrands.data && typeof store.getState().storeBrands.data.data !== "undefined"
			? store.getState().storeBrands.data.data
			: null;

		const categoryNavigationDesktop = [];
		const brands = {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		};

		const getMeta = getStoreCategoryDetail?.data[0]?.meta || {};

		getStoreCategory
			&& getStoreCategory.data[0]
			&& getStoreCategory.data[0].children_data
			&& getStoreCategory.data[0].children_data.map((item) => {

				storeCategory.push({
					id: item.entity_id,
					name: item.category_name,
					slug: item.category_slug,
					children_data: item.children_data,
				});

			});

		getStoreCategoryDesktop
			&& getStoreCategoryDesktop.data[0]
			&& getStoreCategoryDesktop.data[0].children_data
			&& getStoreCategoryDesktop.data[0].children_data.filter((val) => val.include_in_menu === "1").map((item) => {

				categoryNavigationDesktop.push({
					id: item.entity_id,
					name: item.category_name,
					slug: item.category_path,
					is_virtual: item.is_virtual || null,
					items: item.children_data.length > 0
						? item.children_data.map((child) => ({
							id: child.entity_id,
							name: child.category_name,
							slug: child.category_path,
							is_virtual: child.is_virtual || null,
							items: child.children_data.length > 0
								? child.children_data.map((childs) => ({
									id: childs.entity_id,
									name: childs.category_name,
									slug: childs.category_path,
									items: childs.children_data.length > 0
										? childs.children_data.map((lastChilds) => ({
											id: lastChilds.entity_id,
											name: lastChilds.category_name,
											slug: lastChilds.category_path,
										})) : [],
								})) : [],
						})) : [],
				});

			});

		categoryNavigationDesktop.splice(1, 0, brands);

		categoryNavigationDesktop?.map((menu) => {

			menu.items?.map((cat) => {

				const categorySlug = cat?.slug?.split("/");
				const childSlug = categorySlug && categorySlug[categorySlug.length - 1];

				extractCat[childSlug] = cat.id;

				if (cat && cat.items) {

					cat.items.map((subcat) => {

						const slug = subcat?.slug?.split("/");
						const subSlug = slug && slug[slug.length - 1];

						extractCat[subSlug] = subcat?.id;

						if (subcat && subcat.items) {

							subcat.items.map((subsubcat) => {

								const subsubSlug = subsubcat?.slug?.split("/");
								const subCatSlug = subsubSlug && subsubSlug[subsubSlug.length - 1];

								extractCat[subCatSlug] = subsubcat?.id;

							});

						}

					});

				}

			});

			return menu;

		});

		storeCategory.forEach((subcat) => {

			extractParCat[subcat.slug] = subcat.id;
			subcat.children_data.map((subchild) => {

				extractSubCat[subchild.category_slug] = subchild.entity_id;

			});

		});

		getStoreBrands?.map((brand) => {

			extractBrand[brand.brand_id] = brand.brand_name;

		});

		if (Array.isArray(getStoreCategoryDetail?.data) && getStoreCategoryDetail?.data?.[0]?.flashsale_status === "closed") {

			return {
				redirect: {
					permanent: false,
					destination: "/",
				},
			};

		}

		const bannerImage = getStoreCategoryDetail?.data[0]?.detail_page_banner || null;
		return {
			props: {
				query,
				isMobile,
				bannerImage,
				getStoreSelf,
				storeProducts: getStoreProducts || null,
				storeCategoryDesktop: categoryNavigationDesktop || null,
				storeCategory,
				storeBrands: getStoreBrands || null,
				extractCat,
				extractParCat,
				extractSubCat,
				extractBrand,
				getQuoteIdErrMessage,
				getMeta,
				storeCategoryDetail:
					Array.isArray(getStoreCategoryDetail?.data)
						? getStoreCategoryDetail?.data?.[0] ?? {}
						: {},
			}, // will be passed to the page component as props
		};

	},
);

export default Category;
